export default {
    getEkatalogusAdditionalConfig: state => state.eKatalogusTableAdditionalConfig,
    getEkatalogusActions: state => state.eKatalogusActions,
    getEkatalogusRowActions: state => state.eKatalogusRowActions,
    getEkatalogusSelectRowActions: state => state.eKatalogusSelectRowActions,
    getFormActionsEkatalogus: state => state.eKatalogusFormActions,
    getEkatalogusTableSearchFields: state => state.eKatalogusTableSearchFields,
    getEkatalogusTableHeaderFields: state => state.eKatalogusOutpatientTableHeaderFields,
    getEkatalogusOutpatientTableHeaderFields: state => state.eKatalogusOutpatientTableHeaderFields,
    getCovidRapidAntigenTestFields: state => state.covidRapidAntigenTestFields,
    getCovidRapidAntigenTestEkatalogusFields: state => state.covidRapidAntigenTestEkatalogusFields,
    getEkatalogusFeuTableHeaderFields: state => state.eKatalogusFeuTableHeaderFields,
    getEKatalogusEgynaposSebeszetFields: state => state.eKatalogusEgynaposSebeszetFields,

    isGridShow: state => state.gridIsShow,
    isFormShow: state => state.formIsShow
}
